import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getActivity,
  getActivityByFile,
  getActivityByUser,
  getOverview,
  getTimeseries,
} from "../lib/api/activity";
import { qk } from "../lib/queryKeys";
import type {
  ActivityFilterParams,
  ActivityListResponse,
  ByFileResponse,
  ByUserResponse,
  OverviewResponse,
  TimeseriesParams,
  TimeseriesResponse,
} from "../lib/api/types";

export function useActivityOverview() {
  return useQuery<OverviewResponse>({
    queryKey: qk.activityOverview,
    queryFn: getOverview,
  });
}

export function useActivityList(params: ActivityFilterParams) {
  return useQuery<ActivityListResponse>({
    queryKey: qk.activityList(params),
    queryFn: () => getActivity(params),
    placeholderData: keepPreviousData,
  });
}

export function useActivityTimeseries(params: TimeseriesParams) {
  return useQuery<TimeseriesResponse>({
    queryKey: qk.activityTimeseries(params),
    queryFn: () => getTimeseries(params),
    placeholderData: keepPreviousData,
  });
}

export function useActivityByUser(userId: string) {
  return useQuery<ByUserResponse>({
    queryKey: qk.activityByUser(userId),
    queryFn: () => getActivityByUser(userId),
  });
}

export function useActivityByFile(fileId: string) {
  return useQuery<ByFileResponse>({
    queryKey: qk.activityByFile(fileId),
    queryFn: () => getActivityByFile(fileId),
  });
}
